import Link from 'next/link';
import React from 'react'
import { Project } from '../../../models';
import Header from '../header/Header';
import Pill from '../pills/Pill';


interface Props {
  project: Project
}
const ProjectSidebarCard: React.FC<Props> = ({ project }) => {
  return (
    <div>
      <Link href={`/proyectos/${project.slug}`}>
        <a>
          <div className="p-4 bg-white dark:bg-theme-dark-light shadow-xl rounded dark:shadow-none">
            <Header as="h4" className="text-primary">{project.title}</Header>
            {/* <Pill color="red" size="sm" >{project.programmingLevel.name}</Pill> */}
            <p className="whitespace-pre-wrap text-gray-700 text-sm dark:text-gray-200 my-2">
              {project.description}
            </p>
            <div className="flex flex-wrap space-x-1">
              {(project.branches || []).map((branch, index) => (<div key={branch.id} className="text-sm text-highlight-green">#{branch.name.replace(' ', '')}</div>))}
            </div>
          </div>
        </a>
      </Link>
    </div>
  )
}


export default ProjectSidebarCard;